/**
 * Clave del marcador que inyecta la app nativa (`bp-portal-movil`) en el WebView antes de
 * cargar el portal (`constants/webview.ts`, junto con la clase CSS `bp-native-app`).
 */
const NATIVE_APP_STORAGE_KEY = 'bp_movil';

/**
 * Indica si el portal se está ejecutando dentro del WebView de la app de Betterplan.
 *
 * Existe para que las dos lecturas del portal usen la MISMA comparación: antes convivían
 * `=== 'true'`, `!== 'true'` y una versión con `toLowerCase()`, así que un valor `'True'`
 * daba respuestas distintas según la pantalla.
 *
 * El acceso va dentro de `try/catch` porque `localStorage` lanza en contextos donde el
 * almacenamiento está bloqueado (Safari en modo privado, WebView con cookies de terceros
 * deshabilitadas): ahí la respuesta correcta es "no estoy en la app", nunca una excepción.
 */
export function isNativeApp(): boolean {
  try {
    return localStorage.getItem(NATIVE_APP_STORAGE_KEY)?.toLowerCase() === 'true';
  } catch {
    return false;
  }
}
